const normalizeLatestBlogPostsLimit = (limit: number | undefined) => {
  const numericLimit = typeof limit === "number" && Number.isFinite(limit) ? limit : 4;

  return Math.min(Math.max(Math.trunc(numericLimit), 1), 12);
};

const normalizeBlogPostsPage = (page: number | undefined) => {
  const numericPage = typeof page === "number" && Number.isFinite(page) ? page : 1;

  return Math.max(Math.trunc(numericPage), 1);
};

const normalizeBlogPostsPageSize = (pageSize: number | undefined) => {
  const numericPageSize = typeof pageSize === "number" && Number.isFinite(pageSize) ? pageSize : 9;

  return Math.min(Math.max(Math.trunc(numericPageSize), 1), 24);
};

export const getLatestBlogPostsQueryKey = (limit?: number) =>
  ["blog", "latest", { limit: normalizeLatestBlogPostsLimit(limit) }] as const;

export const getBlogPostsPageQueryKey = (page?: number, pageSize?: number) =>
  [
    "blog",
    "list",
    {
      page: normalizeBlogPostsPage(page),
      pageSize: normalizeBlogPostsPageSize(pageSize),
    },
  ] as const;
